import { Field } from '@ark-ui/react';
import { styled, input, type ComponentProps } from '@terra/ui-styled-system';

export const Input = styled(Field.Input, input);
export type InputProps = ComponentProps<typeof Input>;
export type InputSize = NonNullable<InputProps['size']>;
